import React, { useEffect } from "react";
import TransferWeb3 from "./components/TransferWeb3";
import { useNavigate } from "react-router-dom";
import { useApp } from "../../contexts";
import { getSettingByCode } from "../../services/app";

const WithDraw = () => {
  const { user } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    Promise.all([
      getSettingByCode("ENABLE_WALLET"),
      getSettingByCode("ENABLE_WALLET_MEMBER"),
    ])
      .then((response) => {
        const enableWalletData = response[0]?.data?.data || null;
        const enableWalletMemberData = response[1]?.data?.data || null;
        if (enableWalletData) {
          if (enableWalletData.value === "0") {
            navigate("/");
          } else if (enableWalletData.value === "2") {
            if (
              enableWalletMemberData &&
              enableWalletMemberData.value.indexOf(user.email) !== -1
            ) {
            } else {
              navigate("/");
            }
          }
        } else {
          navigate("/");
        }
      })
      .catch((error) => {
        navigate("/");
      });
  }, []);

  return (
    <div>
      <TransferWeb3 />
    </div>
  );
};
export default WithDraw;
